import React, { useEffect, useState } from "react";
import { ArrowLeft, LogOut, Save } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { LOGO_URL } from "@/data/siteContent";
import { api, getApiError } from "@/lib/api";
import SettingsEditor from "@/components/SettingsEditor";
import LeadsPanel from "@/components/LeadsPanel";
import PasswordPanel from "@/components/PasswordPanel";

export default function AdminDashboard({ user, onLogout, onSettingsSaved }) {
  const [draft, setDraft] = useState(null);
  const [leads, setLeads] = useState([]);
  const [pageError, setPageError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Promise.all([api.get("/public/settings"), api.get("/admin/leads")])
      .then(([settingsResponse, leadsResponse]) => { setDraft(settingsResponse.data); setLeads(leadsResponse.data); })
      .catch((error) => setPageError(getApiError(error)));
  }, []);

  const save = async () => {
    setSaving(true);
    setPageError("");
    try {
      const { id, ...payload } = draft;
      const { data } = await api.put("/admin/settings", payload);
      setDraft(data);
      onSettingsSaved(data);
    } catch (error) {
      setPageError(getApiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <header className="admin-topbar" data-testid="admin-topbar">
        <div className="admin-topbar-inner"><a className="admin-brand" href="/" data-testid="admin-home-link"><img src={draft?.logo_url_en || draft?.logo_url || LOGO_URL} alt="Protech logo" /><span><strong>Protech</strong><small>Private editor</small></span></a><div className="admin-topbar-actions"><a className="admin-button" href="/" data-testid="admin-view-site-btn"><ArrowLeft size={14} /> View site</a><button className="admin-button" type="button" onClick={onLogout} data-testid="admin-logout-btn"><LogOut size={14} /> Log out</button></div></div>
      </header>
      <main className="admin-shell">
        <div className="admin-heading"><div><span className="admin-kicker">Signed in / {user.email}</span><h1>Edit the public signal.</h1></div><p>Changes here update the public page in both English and Spanish. Keep the message as clear as the work.</p></div>
        {pageError && <p className="form-error" data-testid="admin-page-error">{pageError}</p>}
        {draft && <div className="admin-layout"><SettingsEditor draft={draft} setDraft={setDraft} onSave={save} saving={saving} /><aside><LeadsPanel leads={leads} /><PasswordPanel /></aside></div>}
      </main>
    </div>
  );
}
